export default {
    path: 'banner',
    component: () => import('../Banner.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách banner',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo banner',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa banner',
            component: () => import('../cu/CU.vue'),
        },
    ]
};